export function getResponseHeaders(error) {
  return error?.response?.headers || {};
}

export function getResponseBodyText(error) {
  const data = error?.response?.data;

  if (typeof data === 'string') {
    return data;
  }

  if (data?.message && typeof data.message === 'string') {
    return data.message;
  }

  return '';
}

export function isKnownSearchAuthResponseBody(body) {
  return /^(Unauthorized|Missing credentials)$/i.test((body || '').trim());
}

export function isAccessBlockedError(error) {
  const status = error?.response?.status ?? error?.statusCode ?? null;

  if (status !== 403) {
    return false;
  }

  const headers = getResponseHeaders(error);
  const cfRay = headers['cf-ray'] || headers['CF-RAY'];
  const cfMitigated = headers['cf-mitigated'] || headers['CF-Mitigated'];
  const blockReason = headers['x-cardladder-block-reason'] || headers['X-CardLadder-Block-Reason'];
  const server = `${headers.server || headers.Server || ''}`.toLowerCase();

  if (blockReason && /vpn/i.test(blockReason)) {
    return true;
  }

  const body = getResponseBodyText(error);

  if (isKnownSearchAuthResponseBody(body)) {
    return false;
  }

  const isCloudflareHtml = /<!DOCTYPE|<html/i.test(body)
    || /cloudflare|ray id|cf-chl|challenge-platform|attention required|sorry,? you have been blocked/i.test(body);

  if (cfRay || cfMitigated || server.includes('cloudflare') || isCloudflareHtml) {
    return true;
  }

  return false;
}
